export const CAMPAIGNS_RESET_STATE = 'CAMPAIGNS_RESET_STATE';
export const CAMPAIGNS_CURRENT_ITEM = 'CAMPAIGNS_CURRENT_ITEM';

export const CAMPAIGNS_REQUEST_LOADING = 'CAMPAIGNS_REQUEST_LOADING';
export const CAMPAIGNS_REQUEST_SUCCESS = 'CAMPAIGNS_REQUEST_SUCCESS';
export const CAMPAIGNS_REQUEST_FAILED = 'CAMPAIGNS_REQUEST_FAILED';

export const CAMPAIGNS_CURRENT_ACTION = 'CAMPAIGNS_CURRENT_ACTION';
export const CAMPAIGNS_RESET_ACTION = 'CAMPAIGNS_RESET_ACTION';
